module.exports = __webpack_public_path__ + "img/skus.a0d59489.svg";